import { compose } from '@wordpress/compose';
import { withDispatch, withSelect } from '@wordpress/data';
import { find, map, size } from 'lodash';
import React from 'react';

import { getPlaylistLink } from '../helpers/ajax';

import './my-playlists.scss';

class myPlaylists extends React.PureComponent {
  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);
    this.onNewPlaylistTitleChange = this.onNewPlaylistTitleChange.bind(this);

    this.state = {
      newPlaylistTitle: '',
      playlistLink: '',
      modalVisible: false,
      renderSinglePlaylist: false,
    };
  }

  toggleModal() {
    const { modalVisible } = this.state;

    this.setState({
      modalVisible: !modalVisible,
    });
  }

  renderPlaylists() {
    const { playlists } = this.props;

    return (
      <ul className="playlists">
        {map(playlists, playlist => (
          <li
            key={playlist.id}
            className="playlist-single"
            onClick={() => {
              this.setState({
                renderSinglePlaylist: playlist.id,
              });
            }}
          >
            <div className="playlist-item">
              <span className="playlist-item-title">{playlist.title}</span>
              <span className="playlist-item-count">{size(playlist.tracks)} Tracks</span>
            </div>
            <div className="playlist-item-action"><i className="fas fa-angle-right"></i>
            </div>
          </li>
        ))}
      </ul>
    );
  }

  onNewPlaylistTitleChange(e) {
    const value = e.target.value;

    this.setState({
      newPlaylistTitle: value,
    })
  }

  renderAddPlaylistForm() {
    const { newPlaylistTitle } = this.state;
    const { addNewPlaylist } = this.props;

    return (
      <div className="new-playlist-form">
        <div className="col">
          <input
            type="text"
            className="input"
            placeholder="New Playlist"
            value={newPlaylistTitle}
            onChange={this.onNewPlaylistTitleChange}
          />
        </div>
        <div className="col">
          <div
            className="newplaylist"
            onClick={() => {
              addNewPlaylist(newPlaylistTitle);
              this.setState({
                newPlaylistTitle: '',
              });
            }}
          >
            <img src="/wp-content/themes/hifi-flavor/img/hifi-addtoplaylist-icon.png" /> New Playlist
          </div>
        </div>
      </div>
    );
  }

  renderMyPlaylists() {
    const { renderSinglePlaylist } = this.state;

    if (renderSinglePlaylist) {
      return null;
    }

    return (
      <React.Fragment>
        <h3 className="title">My Playlists</h3>
        {this.renderPlaylists()}
        {this.renderAddPlaylistForm()}
      </React.Fragment>
    );
  }

  renderSinglePlaylist() {
    const { renderSinglePlaylist, playlistLink } = this.state;
    const { removeTrackFromPlaylist, removePlaylist, playlists } = this.props;

    const playlist = find(playlists, playlist => playlist.id === renderSinglePlaylist);

    if (! renderSinglePlaylist) {
      return null;
    }

    return (
      <div className="playlist-view">
        <div className="playlist-view-title">
          <div
            className="backtoPlaylists"
            onClick={() => {
              this.setState({
                renderSinglePlaylist: false,
                playlistLink: '',
              });
            }}
          >
            <i className="fas fa-angle-left"></i>
          </div>
          <div className="playlist-name">{playlist.title}</div>
          <div
            className="downloadall"
            // href=""
            onClick={() => {
              getPlaylistLink({
                playlist,
                action: 'downloadNewZip',
              }).then(link => {
                window.location = link;
              });
            }}
          >
            <div className="center">
              <div className="btnText">Download<span>.zip</span></div>
              <img src="http://www.shop.hifiproject.com/wp-content/themes/hifi-flavor/img/download-gray.png" />
            </div>
          </div>
        </div>
        <div className="playlist-view-tracks">
          <ul>
            {map(playlist.tracks, track => {
              let trackTitle = track.title;
              if ( track.versionTitle ) {
                trackTitle = trackTitle + ' - ' + track.versionTitle;
              }
              return (
                <li key={track.trackKey} className="playlist-view-track">
                  <div className="playlist-view-track-item"><span className="playlist-view-track-item-title">{trackTitle}</span></div>
                  <div className="playlist-view-track-item-action-download"><a href={`/wp-content/themes/hifi-flavor/download.php?q=${track.versionURL}`} download=""><img src="http://www.shop.hifiproject.com/wp-content/themes/hifi-flavor/img/download-gray.png" className="song-download-img" /></a></div>
                  <div
                    className="playlist-view-track-item-action-close"
                    onClick={() => {
                      removeTrackFromPlaylist(track.trackKey, playlist.id);
                    }}
                  ><i className="fas fa-times"></i></div>
                </li>
              );
            })}

          </ul>
        </div>
        {playlistLink &&
          <div className="playlist-view-link">
            <div className="playlist-link">Your Playlist - <a href={playlistLink} target="_blank">{playlistLink}</a></div>
          </div>
        }
        <div className="playlist-view-footer">
          <div className="footerpl">
            <div className="footerplcolumn">
              <div
                className="createlink"
                onClick={() => {
                  getPlaylistLink({
                    playlist,
                    action: 'createNewPlaylist',
                  }).then(link => {
                    this.setState({
                      playlistLink: link,
                    });
                  });
                }}
              >
                <i className="fas fa-link"></i>
                Create Link
              </div>
            </div>
            <div className="footerplcolumn">
              <div
                className="deleteplaylist"
                onClick={() => {
                  this.setState({
                    renderSinglePlaylist: false,
                  });
                  removePlaylist(playlist.id);
                }}
              >
                <i className="fas fa-times-circle"></i>
                Delete Playlist
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderModal() {
    const { modalVisible } = this.state;

    if (!modalVisible) {
      return null;
    }

    return (
      <div
        className="my-playlists-modal"
      >
        {this.renderMyPlaylists()}
        {this.renderSinglePlaylist()}
      </div>
    );
  }

  render() {
    return (
      <div
        className="my-playlists"
      >
        <span
          className="title-wrap"
          onClick={this.toggleModal}
        >
          <img src="/wp-content/themes/hifi-flavor/img/music-menu.png" />
          <span className="title">My Playlists</span>
        </span>
        {this.renderModal()}
      </div>
    );
  }
}

const MyPlaylists = compose(
  withSelect(select => {
    const { getPlaylists } = select('hifi');

    return {
      playlists: getPlaylists(),
    };
  }), withDispatch(dispatch => {
    const { addNewPlaylist, removePlaylist, removeTrackFromPlaylist } = dispatch('hifi');

    return {
      addNewPlaylist,
      removePlaylist,
      removeTrackFromPlaylist,
    };
  }))(myPlaylists);

export default MyPlaylists;

